import { render } from "./comtags.vue?vue&type=template&id=612ef90b&scoped=true"
const script = {}

import "./comtags.vue?vue&type=style&index=0&id=612ef90b&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612ef90b"]])

export default __exports__